import {
    LOAD_RESTAURANT_PRODUCTS_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_RESTAURANT_PRODUCTS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/promotions/RestaurantProductsReducer.js